<template>
  <i-card :dis-hover="true" class="setting-card">
    <div class="header" @click="accordionToggle()">
      <h3>
        <slot name="title" />
      </h3>
      <div class="header__btn">
        <i-badge>
          <i-button>{{ btnText }}</i-button>
          <template v-if="isPassword">
            <i-icon v-if="!_isOpen" type="md-lock" style="font-size:22px; color: #333;" slot="count" />
          </template>
        </i-badge>
      </div>
    </div>
    <p>
      <slot name="notice" />
    </p>

    <transition
      name="js-accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div v-if="_isOpen" class="js-accordion--target" :class="{ '_state-open': _isOpen }">
        <slot name="contents" />
        <div>
          <i-button type="error" @click="onClickSave" style="float:right;">保存</i-button>
        </div>
      </div>
    </transition>
  </i-card>
</template>

<script>
import { Card, Button, Badge, Icon } from 'view-design'
export default {
  components: {
    'i-card': Card,
    'i-button': Button,
    'i-badge': Badge,
    'i-icon': Icon,
  },
  props: {
    isOpen: {
      type: Boolean,
      defalult: false,
      required: true,
    },
    isPassword: {
      type: Boolean,
      defalult: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    _isOpen: {
      get() {
        return this.isOpen
      },
      set(val) {
        this.$emit('update:isOpen', val)
      },
    },
    btnText() {
      return this._isOpen ? '閉じる' : '開く'
    },
  },
  methods: {
    accordionToggle: function() {
      this.$emit('accordion')
    },
    beforeEnter: function(el) {
      el.style.height = '0'
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leave: function(el) {
      el.style.height = '0'
    },
    // サイト設定登録処理
    async onClickSave() {
      this.$emit('save')
    },
  },
}
</script>

<style lang="scss" scoped>
.setting-card {
  margin-bottom: 8px;
  background-color: #fff;
  .header {
    position: relative;
    cursor: pointer;
    color: #2d8cf0;
    transition: ease 0.8s all;
    &:hover {
      opacity: 0.8;
    }
    &__btn {
      position: absolute;
      top: -6px;
      right: 0;
    }
  }
  .ivu-card-bordered {
    margin-bottom: 6px;
  }
  .ivu-card-body p {
    margin-top: 8px;
  }

  .js-accordion--target {
    transition: height 0.4s ease-in-out;
    font-size: 12px;
  }
  .js-accordion-enter-active {
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: js-accordion--anime__opend;
  }
  .js-accordion-leave-active {
    animation-duration: 0.4s;
    animation-fill-mode: both;
    animation-name: js-accordion--anime__closed;
  }

  @keyframes js-accordion--anime__opend {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @keyframes js-accordion--anime__closed {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }
}
</style>
